import React from "react";
import Seo from "../seo/seo";

const TermsOfService: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
      <Seo
        title="Terms of Service | Merge Images Stackasian"
        description="Read the terms of service for Merge Images Stackasian, outlining the rules and guidelines for using our website and services."
      />
      <h1 className="text-3xl font-bold mb-6 text-center">Terms of Service</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold">Introduction</h2>
          <p>
            Welcome to Merge Images Stackasian. By using our website and services, you agree to comply with and be bound by the following Terms of Service. Please read them carefully.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Use of Services</h2>
          <p>
            You agree to use Merge Images Stackasian only for lawful purposes. You may not use our services in a manner that violates any applicable laws or regulations.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Account Registration</h2>
          <p>
            You may be required to create an account to access certain features of Merge Images Stackasian. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Content Usage</h2>
          <p>
            All content available on Merge Images Stackasian, including worksheets, exams, and other resources, is owned by us or our content providers. You may use this content solely for personal, non-commercial purposes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Limitation of Liability</h2>
          <p>
            We are not liable for any damages or losses arising from the use of our website or services. You use our services at your own risk.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account if you violate any of our terms or engage in behavior that is harmful to the website or other users.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Governing Law</h2>
          <p>
            These Terms of Service are governed by the laws of the jurisdiction in which Merge Images Stackasian operates.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Changes to Terms of Service</h2>
          <p>
            We may update these Terms of Service from time to time. We will notify you of any significant changes, and the updated terms will be posted on this page.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at Merge Images Stackasian.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;